import React, { createContext, useEffect, useState, useContext } from "react";
import { isLocalPrinterReady, getIsZebraUsbReady } from "../../utils/prodlocalhelper";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { connect } from "react-redux";

import MessageOkModal from "../modal/modalWindow/messageOkModal"
import ConfirmationModal from "../modal/modalWindow/confirmationModal"
 
const AppContext = createContext();

const useAppContext = () => useContext(AppContext);
const AppProvider = (props) => {
    const [printerStatus, setPrinterStatus] = useState('idle');
    const [printerName, setPrinterName] = useState();

    const [printerStatusRFID, setPrinterStatusRFID] = useState('idle');
    const [printerNameRFID, setPrinterNameRFID] = useState();

    const [showMessageModal, setShowMessageModal] = useState();
    const [messageModalConfig, setMessageModalConfig] = useState();

    const [showConfirmationModal, setShowConfirmationModal] = useState();
    const [confirmationModalConfig, setConfirmationModalConfig] = useState();

    useEffect(()=>{
      const intervalId= setInterval(()=>{
        isLocalPrinterReady((err, res) => {
          if (err) {
            setPrinterStatus('ERROR')
            setPrinterName(t("dashboard_main.local_printer_not_ready"))
            console.log(err);
          } else {
            setPrinterStatus(res.data.status)
            setPrinterName(res.data.name)
          }
        });
        getIsZebraUsbReady((err, res) => {
          if (err) {
            setPrinterStatusRFID('ERROR')
            setPrinterNameRFID(t("dashboard_main.local_printer_not_ready"))
            console.log(err);
          } else {
            setPrinterStatusRFID(res.data.status)
            setPrinterNameRFID(res.data.name)
          }
        });
      },10000)

      return () => clearInterval(intervalId);
    },[])

    const openMessageModal=(title, message)=>{
        setMessageModalConfig({title, message});
        setShowMessageModal(true);
    }

    const openConfirmationModal=(title, message, okCallback=()=>{}, cancelCallback=()=>{})=>{
      setConfirmationModalConfig({title, message, okCallback, cancelCallback});
      setShowConfirmationModal(true);
    }

    return (
        <AppContext.Provider value={{
            printerStatus:printerStatus,
            printerName:printerName,
            printerStatusRFID:printerStatusRFID,
            printerNameRFID:printerNameRFID,
            showMessage:openMessageModal,
            showConfirmationMessage:openConfirmationModal
        }}>
            {props.children}
            <MessageOkModal
                open={showMessageModal}
                title={messageModalConfig?.title}
                children={messageModalConfig?.message}
                button1Title={t('ok')}
                onConfirm={()=>{setShowMessageModal(false)}}
            />
            <ConfirmationModal
                open={showConfirmationModal}
                title={confirmationModalConfig?.title}
                children={confirmationModalConfig?.message}
                button1Title={t('ok')} 
                button2Title={t('cancel')} 
                onConfirm={()=>{
                  setShowConfirmationModal(false);
                  confirmationModalConfig.okCallback();
                }}
                onCancel={()=>{
                  setShowConfirmationModal(false);
                  confirmationModalConfig.cancelCallback();
                }}
            />
        </AppContext.Provider>
    );
}

export {useAppContext };



export default AppProvider;
